<ng-container *ngIf="!noEmail">
  <section *ngIf="verifiedUser">
    <h2 class="title" translate>
      components.list.password.connectToInviertis
    </h2>
    <p class="subtitle" translate>
      components.list.password.createPasswordToEnter
    </p>
    <form [formGroup]="formToCreatePassword" (ngSubmit)="save()">
      <div class="container-inputs">
        <label class="d-block">
          <input
            id="email-inp"
            type="email"
            class="form-control"
            formControlName="email"
            [placeholder]="'Email'"
          />
          <span hidden>Email</span>
          <div
            *ngIf="
              formToCreatePassword.controls.email.invalid &&
              (formToCreatePassword.controls.email.dirty ||
                formToCreatePassword.controls.email.touched)
            "
          >
            <small
              *ngIf="formToCreatePassword.controls.email.errors?.required"
              class="text-danger"
              translate
            >
              components.registro.emailRequired
            </small>
            <small
              *ngIf="formToCreatePassword.controls.email.errors?.minlength"
              class="text-danger"
              translate
            >
              components.registro.emailMinChars
            </small>
            <small
              *ngIf="formToCreatePassword.controls.email.errors?.maxlength"
              class="text-danger"
              translate
            >
              components.registro.emailMaxChars
            </small>
          </div>
        </label>

        <label class="d-block">
          <input
            id="firstname-inp"
            type="text"
            class="form-control"
            formControlName="first_name"
            autocomplete="first_name"
            placeholder="{{ 'Nombre' | translate }}"
          />
          <span hidden translate>components.registro.name</span>
          <div
            *ngIf="
              formToCreatePassword.controls.first_name.invalid &&
              (formToCreatePassword.controls.first_name.dirty ||
                formToCreatePassword.controls.first_name.touched)
            "
          >
            <small
              *ngIf="formToCreatePassword.controls.first_name.errors?.required"
              class="text-danger"
              translate
            >
              components.registro.nameRequired
            </small>
            <small
              *ngIf="formToCreatePassword.controls.first_name.errors?.maxlength"
              class="text-danger"
              translate
            >
              components.registro.nameMaxChars
            </small>
            <small
              *ngIf="formToCreatePassword.controls.first_name.errors?.pattern"
              class="text-danger"
              translate
            >
              components.registro.noSpecialChars
            </small>
          </div>
        </label>

        <label class="d-block">
          <input
            id="lastname-inp"
            type="text"
            class="form-control"
            formControlName="last_name"
            autocomplete="last_name"
            placeholder="{{ 'Apellido' | translate }}"
          />
          <span hidden>Last Name</span>
          <div
            *ngIf="
              formToCreatePassword.controls.last_name.invalid &&
              (formToCreatePassword.controls.last_name.dirty ||
                formToCreatePassword.controls.last_name.touched)
            "
          >
            <small
              *ngIf="formToCreatePassword.controls.last_name.errors?.required"
              class="text-danger"
              translate
            >
              components.registro.surnameRequired
            </small>
            <small
              *ngIf="formToCreatePassword.controls.last_name.errors?.maxlength"
              class="text-danger"
              translate
            >
              components.registro.surnameMaxChars
            </small>
            <small
              *ngIf="formToCreatePassword.controls.last_name.errors?.pattern"
              class="text-danger"
              translate
            >
              components.registro.surnameNoSpecialChars
            </small>
          </div>
        </label>

        <label class="d-block">
          <app-countries-autocomplete
            [control]="formToCreatePassword.get('code_country')"
          ></app-countries-autocomplete>
          <span hidden>Last Name</span>
        </label>

        <label class="d-block">
          <div class="d-flex">
            <input
              id="phone-inp"
              class="form-control"
              formControlName="phone"
              placeholder="{{ 'Teléfono' | translate }}"
              appMaxLength
              [maxLength]="12"
              type="text"
            />
          </div>
          <span hidden translate>components.registro.telephone</span>
          <div
            *ngIf="
              formToCreatePassword.controls.phone.invalid &&
              (formToCreatePassword.controls.phone.dirty ||
                formToCreatePassword.controls.phone.touched)
            "
          >
            <small
              *ngIf="formToCreatePassword.controls.phone.errors?.required"
              class="text-danger"
              translate
            >
              components.registro.telephoneRequired
            </small>
            <small
              *ngIf="formToCreatePassword.controls.phone.errors.pattern"
              class="text-danger"
              translate
            >
              components.registro.onlyNumbers
            </small>
          </div>
        </label>

        <div class="margin-dropdown password mb-3">
          <input
            [type]="showPassword ? 'password' : 'text'"
            class="form-control"
            placeholder="{{ 'Contraseña' | translate }}"
            formControlName="password"
          />
          <i
            [class]="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
            (click)="hidePassword()"
          ></i>
        </div>
        <div class="margin-dropdown password mb-3">
          <input
            [type]="showPassword ? 'password' : 'text'"
            class="form-control"
            placeholder="{{ 'Repetir contraseña' | translate }}"
            formControlName="repeat_password"
          />
          <i
            [class]="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
            (click)="hidePassword()"
          ></i>
        </div>
        <div class="dato mb-2">
          <span class="mandatory" translate
          >components.stepBasics.howContactYou</span
          >
          <div>
            <input
              class="mx-2"
              type="checkbox"
              formControlName="contact_email"
            />
            <label class="m-0" for="acceptNotifications" translate
            >components.venderPortal.byEmail</label
            >
          </div>
          <div>
            <input
              class="mx-2"
              type="checkbox"
              formControlName="contact_phone"
            />
            <label class="m-0" for="acceptNotifications" translate
            >components.venderPortal.byPhone</label
            >
          </div>
          <div>
            <input class="mx-2" type="checkbox" formControlName="contact_sms" />
            <label class="m-0" for="acceptNotifications" translate
            >components.venderPortal.byChat</label
            >
          </div>
        </div>

        <button
          [disabled]="
            formToCreatePassword.invalid && acceptNotifications === false
          "
          class="btn btn-primary input"
          translate
        >
          components.list.password.send
        </button>
        <div class="d-flex justify-content-center mt-3">
          <input
            class="mx-2"
            type="checkbox"
            id="acceptNotifications"
            [(ngModel)]="acceptNotifications"
            [ngModelOptions]="{ standalone: true }"
          />
          <label class="m-0" for="acceptNotifications" translate
          >components.registro.wantReceiveInfo</label
          >
        </div>
      </div>
    </form>
  </section>
</ng-container>
<ng-container *ngIf="noEmail">
  <div class="poppins page-error">
    <span class="title-er" translate
    >components.helpers.¡Ups! Lamentamos las molestias...</span
    >
    <span class="sub-title-er" translate
    >components.helpers.No se encontro el email, Verifique su email</span
    >
    <button class="btn-blue" (click)="gotoHome()" translate>
      components.helpers.Ir a la Home
    </button>
  </div>
</ng-container>
